import { type ActionKind } from '@blaze-shared/elements-domain';

import {
  type ChatActionType,
  type ChatActionWorkflowContext,
  type ChatContext,
  type OutgoingChatActionWorkflowContext,
  type OutgoingChatContext,
  type PendingActionTarget,
} from './chat-context.models';

export function toOutgoingChatContext(context: ChatContext): OutgoingChatContext | undefined {
  switch (context.$type) {
    case 'project':
    case 'workflow':
      return undefined;
    case 'component':
    case 'source_workflow': {
      const { componentId: _id, componentTypeName: _typeName, ...outgoing } = context;
      return outgoing;
    }
    case 'action_workflow':
      return toOutgoingActionWorkflowContext(context);
    case 'table':
    case 'page':
      return context;
  }
}

const ACTION_TYPE_BY_GENERATION_TYPE: Readonly<Record<ActionKind, ChatActionType>> = {
  row: 'Action',
  bulk: 'BulkAction',
  step: 'Action',
  other: 'Action',
};

function toOutgoingActionWorkflowContext(
  context: ChatActionWorkflowContext,
): OutgoingChatActionWorkflowContext {
  const { componentId, dataSourceWorkflow } = context;
  return {
    $type: 'action_workflow',
    pageName: context.pageName,
    component: context.component,
    actionType: ACTION_TYPE_BY_GENERATION_TYPE[context.actionGenerationType],
    workflows: componentId && dataSourceWorkflow ? { [componentId]: dataSourceWorkflow } : {},
  };
}

export function toPendingActionTarget(context: ChatContext): PendingActionTarget | undefined {
  if (context.$type !== 'action_workflow' || !context.componentId) {
    return undefined;
  }
  return { elementId: context.componentId, actionPath: context.actionPath };
}
